import React, { Fragment, useState, useEffect } from 'react';
import {
    Button,
    Row,
    Card,
    Input,
    ButtonGroup,
    CardBody,
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
export default function CustomCss({
    botSettings,
    saveIntegration,
}) {
    const [inputData, setInputData] = useState(
        {
            text: ""
        }
    );
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(botSettings.customCss !== null &&
        !botSettings.customCss.isDisabled
    );
    useEffect(() => {
        if (botSettings !== null && botSettings.customCss !== null) {
            setInputData({
                ...botSettings.customCss,
                text: botSettings.customCss.text
            });
        }
        console.log(botSettings.customCss);
    }, [botSettings]);

    const handleSwitchChange = (value) => {
        setCheckedPrimarySmall(value);
        setInputData({
            ...inputData,
            isDisabled: value
        });
    };
    const handleTextChange = (e) => {
        setInputData({ ...inputData, text: e.target.value });
    }
    const handleSave = () => {
        botSettings.customCss = inputData;
        saveIntegration({ botSetting: botSettings });
    }
    return (
        <Fragment>
            <Card>
                <CardBody name="bodyClick text-center">
                    <div className="col-md-12 text-center">
                        <h6>Custom CSS</h6>
                        <p>Use CSS to customize your Digital Compendium</p>
                    </div>
                    <Separator className="mb-3" />
                    <Card className="m-4 p-4">
                        <div className="mb-1 d-flex align-items-center">
                            <h6>Enabled</h6>
                            <Switch
                                className="custom-switch-primary custom-switch-small ml-2"
                                checked={checkedPrimarySmall}
                                onChange={(primary) => handleSwitchChange(primary)}
                            />
                        </div>
                        <div className="mb-1">
                            <span>
                                While most changes can be made with settings in,
                                you may prefer to use CSS to customize further if you have experience writing CSS code.
                            </span><br /><br />
                            <span className="ml-1"><b>Type or paste your CSS into the text box provided.</b></span>
                        </div>
                        <div className="mb-2">
                            <Input
                                type="textarea"
                                value={inputData.text}
                                name="text"
                                onChange={(e) => handleTextChange(e)}
                                style={{ height: "70px" }}
                            />
                        </div>
                    </Card>
                    <Separator className="mb-3" />
                    <div className='d-flex justify-content-center mb-1'>
                        <Button color="primary" size="xs" onClick={handleSave}>
                            Save
                        </Button>
                    </div>
                </CardBody>
            </Card>
        </Fragment >)
}